export enum QueueStatus
{
  ready,
  locked,
  complete,
  notLoaded,
  pendingSupervisor,
}
